(function () {
    'use strict';
    var controllerId = 'competitorProductsListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', competitorProductsListCtrl]);
    function competitorProductsListCtrl(common, datacontext, $scope, $routeParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.competitor_products = [];
        $scope.store_product_id = $routeParams.spid;

        activate();

        function activate() {
            var promises = [
                getCompetitorProducts()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Competitor Products View');
                });
        }

        function getCompetitorProducts() {
            return datacontext.competitor_product_list({store_product_id:$scope.store_product_id, active:1}).then(function (httpResult) {

                vm.competitorProducts = httpResult.data.data;
            });
        }
    }
})();

(function () {
    'use strict';
    var controllerId = 'PhantomApprovalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', PhantomApprovalCtrl]);
    function PhantomApprovalCtrl(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.pending_approval = [];

        activate();

        function activate() {
            var promises = [
                getPendingPhantom()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Competitor Products View');
                });
        }
        function getPendingPhantom() {

            return datacontext.qPhantomReview().then(function(httpResult) {
                vm.pending_approval = httpResult.data.data;
            });
        }

        $scope.updatePhantom = function (data) {

            var data = {
                action_id: data.action_id,
                store_product_id: data.store_product_id
            };

            datacontext.update_phantom_products(data).then(function () {
                // get next
                getPendingPhantom();
            });
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'getCompetitorSummaryCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', 'NgTableParams', getCompetitorSummaryCtrl]);
    function getCompetitorSummaryCtrl(common, datacontext, $scope, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.startSearch = 0;

        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            search:'',
            order_by:'product_count',
            order_dir:'desc',
            page:1,
            limit:100
        };

        activate();

        function activate() {
            var promises = [
                get_competitor_summary()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Competitor Products View');
                });
        }

        function get_competitor_summary() {
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;


                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_competitor_summary(vm.query).then(function (httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }
    }
})();


